(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product_back_instock"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ace-stock-popup')) {
  customElements.define('ace-stock-popup', class extends HTMLElement {
    connectedCallback() {
      if (this.stockPopupInitialised) return;
      this.stockPopupInitialised = true;
      const dialog = this.querySelector('dialog');
      const trigger = this.querySelector('.ace-stock-popup__trigger');
      const form = this.querySelector('form');
      if (!dialog || !trigger || !form) return;
      dialog.addEventListener('toggle', () => {
        trigger.setAttribute('aria-expanded', String(dialog.open));
        if (dialog.open) {
          const focusTarget = dialog.querySelector('.ace-stock-popup__status') || dialog.querySelector('input[type="email"]');
          focusTarget?.focus({ preventScroll: true });
        } else if (trigger.isConnected && !this.closest('hdt-back-instock')?.hidden) {
          trigger.focus({ preventScroll: true });
        }
      });
      const url = new URL(window.location.href);
      const returnedForm = url.searchParams.get('contact[id]') || decodeURIComponent(url.hash.slice(1));
      if (returnedForm !== form.id || (!url.searchParams.has('contact_posted') && !this.hasAttribute('data-form-status'))) return;
      const notification = this.closest('hdt-back-instock');
      if (notification) notification.hidden = false;
      customElements.whenDefined('hdt-modal').then(() => {
        if (this.isConnected) dialog.parentElement.open(true);
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
